import { StageContract } from "./StageContract";

export default StageContract;